import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Button } from 'hljd'
import AddModal from './AddModal'
import List from './List'
import store from './store'
import { observer } from 'mobx-react'
@observer
export default class extends Component {
  componentDidMount() {
    store.getList()
  }

  render() {
    return (
      <HeaderView title="店铺公告">
        <div style={{ paddingTop: 30, fontSize: 14 }}>
          <p style={{ padding: '0 0 30px 4px' }}>
            当您设置了店铺公告后，会在您的客户端商家主页中醒目的位置展示您填写的公告信息，您可以自由填写活动优惠等信息！{' '}
          </p>
          {store.list.length === 0 && (
            <Button
              type="primary"
              style={{ width: 116, height: 38, marginBottom: 30 }}
              onClick={store.showModal()}
            >
              发布公告
            </Button>
          )}
          <List />
          <AddModal />
        </div>
      </HeaderView>
    )
  }
}
